import ChargeStationLeafletMapView from '../../components/ChargeStationLeafletMapView';

ChargeStationIframeMapScreen.propTypes = {};

function ChargeStationIframeMapScreen(props) {
  return (
    <div className="container-fluid px-0">
      <ChargeStationLeafletMapView iframeMode={true} />
    </div>
  );
}

export default ChargeStationIframeMapScreen;
